import { config } from './../../../config/pages-config';

/** CONTRACT_TYPES_LIST */
export const CONTRACT_TYPES_LIST = {
    KAY: 'kay',
    BART: 'bart',
    MARIE: 'marie',
    ANNA: 'anna',
    PETER: 'peter',
    PAUL: 'paul',
    RALF: 'ralf',
    MARK: 'mark',
    EMMA: 'emma',
    MARTIN: 'martin',
    DONALD: 'donald',
    DELLA: 'della',
    DAISY: 'daisy',
    UTE: 'ute',

};
/** DUNNING_AMOUNT_TYPE */
export const DUNNING_AMOUNT_TYPE = {
    arBalance: 'arBalance',
    letterAmount: 'dunningLetterAmount',
};

/** SESSION_STORAGE_CUSTOMER_CLASS */
export const SESSION_STORAGE_CUSTOMER_CLASS = 'ecare.data.payment.customer.class';

/** SESSION_STORAGE_DUNNING_KEY */
export const SESSION_STORAGE_DUNNING_KEY = 'ecare.data.dunning';
/** SESSION_STORAGE_PAYMENT_ITEM */
export const SESSION_STORAGE_PAYMENT_ITEM = 'ecare.data.payment.item';
/** dunningUseCase */
export const dunningUseCase = {
    name: 'dunning',
    useCase: 'FulfillPaymentDunning',
    channelId: 'meinVodafone-Web',
    clientID: 'mvf',
    idType: 'BAN',
};
/** DSL_USECASE */
export const DSL_USECASE = {
    name: 'DSLPayment',
    useCase: 'DSLPayment',
    channelId: 'meinVodafone-web',// for opweb4 >> VFopweb4,
    clientID: 'DSL',// for opweb4 >> eaiopweb4,
    idType: 'DSLCUSTOMER',
};

/** DSLCUSTOMER */
export const DSLCUSTOMER = 'DSLCUSTOMER';
/** DSLACCOUNT */
export const DSLACCOUNT = 'DSLACCOUNT';


/** SESSION_STORAGE_PAYMENTMETHODS_KEY */
export const SESSION_STORAGE_PAYMENTMETHODS_KEY = 'ecare.data.dunning.paymentMethods';
/** channelIdForWeb  */
export const channelIdForWeb = 'meinVodafone-Web';
/** channelIdForApp */
export const channelIdForApp = 'meinVodafone-App-webview';
/** AMAZONPAY_NAMES  */
export const AMAZONPAY_NAMES = {
    AMAZONPAY: 'AMAZONPAY',
    AMAZON: 'AMAZON',
};

/** MODULE_NAMES */
export const MODULE_NAMES = {
    registrationModule: 'registration',
    addContractModule: 'addContract',
    loginModule: 'login',
    topupPayment: 'topupPayment',
};

/** Mobile_CONTRACT_TYPES */
export const Mobile_CONTRACT_TYPES = {
    EK: 'EK',
    KD: 'KD',
    TN: 'TN',
    callYa: 'callYa',
    MMO: 'MMO',
};

/** CONTRACT_TYPES */
export const CONTRACT_TYPES = {
    mobile: {
        name: 'mobile',
    },
    dsl: {
        name: 'dsl',
    },
    cable: {
        name: 'cable',
    },
    fixednet: {
        name: 'fixednet',
    },
    unityMedia: {
        name: 'unitymedia',
    },
};

/** SECURITY_QUESTION_TYPES */
export const SECURITY_QUESTION_TYPES = {
    update: 'update',
    reuse: 'reuse',
    delete: 'delete',
};

/** USER_SESSION_KEY_PREFIX */
export const USER_SESSION_KEY_PREFIX = {
    data: 'ecare-LocalStore.data.',
    keys: 'ecare-LocalStore.keys',
};

/** ACCESS_LEVELS_LIST */
export const ACCESS_LEVELS_LIST = {
    ACCOUNT: 'account',
    CONTRACT: 'contract',
    SUBSCRIPTION: 'subscription',
    CONTRACT_OR_SUBSCRIPTION: 'contractOrSubscription',
};

/** ACTORS */
export const ACTORS = {
    kay: 'kay',
    marie: 'marie',
    peter: 'peter',
    paul: 'paul',
    mark: 'mark',
    anna: 'anna',
    emma: 'emma',
    ralf: 'ralf',
    martin: 'martin',
    bart: 'bart',
    eric: 'eric',
    donald: 'donald',
    ute: 'ute',
};

/** MARKETCODES */
export const MARKETCODES = {
    mmc: 'MMC',
    mmo: 'MMO',
    puc: 'PUC',
    pua: 'PUA',
};

/** SUBTYPES */
export const SUBTYPES = {
    ek: 'EK',
    kd: 'KD',
    tn: 'TN',
    dsl: 'DSL',

};
/** CONTRACTTYPES */
export const CONTRACTTYPES = {
    postPaid: 'post-paid',
    prePaid: 'pre-paid',
    fixedNet: 'fixedNet',
    cable: 'cable',
};

/** LOG_LEVELS */
export const LOG_LEVELS = {
    OFF: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4,
    LOG: 5,
};

/** CONTRACT_TYPE */
export const CONTRACT_TYPE = {
    DSL: 'dsl',
    MOBILE: 'mobile',
    CABLE: 'cable',
};

/** LOGOUT_IDEL_CONF */
export const LOGOUT_IDEL_CONF = {
    IDEL_TIME: 20,
    TIMEOUT_TIME: 720,
    PING_INTERVAL: 15,
    TARGET_URL_ID: 'targetURL',
    LOGOUT_FORM_ID: 'logoutform',
};

/** AUTHENTICATION_ERROR_CODE */
export const AUTHENTICATION_ERROR_CODE = {
    MINT_AUTHENTICATION_REQUIRED: 'authentication-required',
    NIL_AUTHENTICATION_REQUIRED: 'NIL00A001',
};

/** AUTHORIZATION_ERROR_CODE */
export const AUTHORIZATION_ERROR_CODE = {
    SECURITY_CHALLENGE_FAILED: 'security-challenge-failed',
};

/** AUTHENTICATION_WHITELIST */
export const AUTHENTICATION_WHITELIST: Array<string> = [MODULE_NAMES.loginModule];

/** PAGE_TYPE */
export const PAGE_TYPE = {
    ONE_TIME_TRANSACTION: 'oneTimeTransaction',
};

/** DISABLE_DEEP_LINKS_WHITE_LIST */
export const DISABLE_DEEP_LINKS_WHITE_LIST: string[] = [
    // config.loginDayOne.route,
    // config.firstLogin.route,
    // config.changeONBUsername.route,
    config.generalError.route,
];

/** TRIM_TYPES */
export const TRIM_TYPES = {
    TRIM: 'trim',
    ALL: 'all',
};

/** SIMPLICITY_ENV */
export const SIMPLICITY_ENV = {
    dev: 'dev',
};

/** WORDING_FILES */
export const WORDING_FILES = {
    defaultWording: 'defaultWording',
    deWording: 'deWording',
};

/** PAYMENT_CONFIG */
export const PAYMENT_CONFIG = {
    /** remove at production 'FulfillPayment' */
    // USECASE: 'PrepayTest',
    MOBILCOMP_USECASE: 'FreenetPayment',
    USECASE: 'FulfillPayment',
    CLIENTID: 'web',
    WEB_CHANNELID: 'meinVodafone-Web',
    MOBILE_CHANNELID: 'meinVodafone-App-webview',
    VALENCIA_MOBILE_CHANNELID: 'Valencia-App-webview',
    CURRENCY: 'EUR',
    idType: {
        ANONYMOUS: 'ANONYMOUS',
        MSISDN: 'MSISDN',
        BAN: 'BAN',
        ONLINEUSERID: 'ONLINEUSERID',
    },
    personalDataSubscriptionsRange: [2, 10],
    paymentHistoryStauts: {
        SUCCESS: 'SETTLED',
        PENDING: 'PENDING',
        FAILED: 'FAILED',
    },
    paymentHistoryType: {
        CREDITCARD: 'CREDITCARD',
        PAYPAL: 'PAYPAL',
        GOOGLEPAY: 'GOOGLEPAY',
        DIRECTEBANKING: 'DIRECTEBANKING',
        APPLEPAY: 'APPLEPAY',
        AMAZONPAY: 'AMAZON',
    },
};

/** PAYMENT_STATUS */
export const PAYMENT_STATUS = {
    ACCEPTED: 'ACCEPTED',
    BARRED: 'BARRED',
    UNKNOWN: 'UNKNOWN',
    lIMIT_REACHED: 'lIMIT_REACHED',
    TOPUP_NOT_REACHED: 'TOPUP_NOT_REACHED',
    LIMITED: 'LIMITED',
};
/** SHOPPER_STATUS_POST */
export const SHOPPER_STATUS_POST = {
    BARRED_MIN_AMOUNT_ERROR_VALUE: 200,
    BARRED_MIN_AMOUNT_NEVER_TOPUP_BEFORE_VALUE: 1500,
};

/** SUBMIT_PAYMENT_STATUS */
export const SUBMIT_PAYMENT_STATUS = {
    AUTHORISED: 'AUTHORISED',
    PENDING: 'PENDING',
    REFUSED: 'REFUSED',
    ERROR: 'ERROR',
    CANCELLED: 'CANCELLED',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
};

/** PAYMENT_ERRORS_CODE */
export const PAYMENT_ERRORS_CODE = {
    PAYER_BARRED: 'PAYER_BARRED',
    RECIEVER_BARRED: 'RECIEVER_BARRED',
    RECIEVER_UNKNOWN: 'RECIEVER_UNKNOWN',
    DOUBLE_BOOKING: ['NIL0F1002', 'NIL0F1016'],
};

/** DATA_LOSS_WHITELIST */
export const DATA_LOSS_WHITELIST = [
    config.generalError.route,
    config.logout.timeoutUrl,
];

/** MOBILE_VIEW_KEYS */
export const MOBILE_VIEW_KEYS = {
    VALENCIA: 'VALENCIA',
    MEIN_VODAFONE: 'MEIN_VODAFONE',
};

/** TOPUP_PAYMENT */
export const TOPUP_PAYMENT = {
    PRODUCT_AMOUNT: 'productAmount',
};

/** PAYMENT_SESSION_STORAGE */
export const PAYMENT_SESSION_STORAGE = {
    MOBILE_VIEW_KEY: 'mobileView',
    PAYMENT_KEY: 'topups',
    SELECTED_PAYMENT_METHOD: 'selectedMethod',
    PAYMENT_CONFIG: 'paymentConfig',
    PAYMENT_METHOD_CONFIG: 'paymentMethodConfig',
    AMAZON_PAY_SESSION_DATA: 'amazonPaySessionData',
};

/** PAYMENT_QUERYPARAMTER_HEADER */
export const PAYMENT_QUERYPARAMTER_HEADER = 'hideheader';
/** PAYMENT_QUERYPARAMTER_FORAPP */
export const PAYMENT_QUERYPARAMTER_FORAPP = 'forApp';
/** PAYMENT_QUERYPARAMTER_AMOUNT */
export const PAYMENT_QUERYPARAMTER_AMOUNT = 'product';
/** PAYMENT_MOBILE_CLASS */
export const PAYMENT_MOBILE_CLASS = 'mobile-web-view';

/** CREDIT_CARD_REGEX_KEY */
export const CREDIT_CARD_REGEX_KEY = 'creditCard';

/** INTERNATIONAL_PHONE_NUMBER_REGEX_PASTE */
export const INTERNATIONAL_PHONE_NUMBER_REGEX_PASTE = 'internationalPhoneNumberRegexPaste';

/** PAYMENT_DELAY_TIME */
export const PAYMENT_DELAY_TIME = 10000;

/** ERORR_REGEX_AMOUNT */
export const ERORR_REGEX_AMOUNT = 'ERORR_REGEX_AMOUNT';

/** PAYMENT_METHODS */
export const PAYMENT_METHODS = {
    CREDITCARD: 'CREDITCARD',
    PAYPAL: 'PAYPAL',
    GOOGLEPAY: 'GOOGLEPAY',
    DIRECTEBANKING: 'DIRECTEBANKING',
    APPLEPAY: 'APPLEPAY',
    AMAZONPAY: 'AMAZON',
};

/** PAYMENT_URL */
export const PAYMENT_URL = 'meinvodafone/account';

/** PAYMENT_USECASE_COOKIE_KEY */
export const PAYMENT_USECASE_COOKIE_KEY = 'payment-usecase-draft';

/** MTAN_STATIC_VALUES */
export const MTAN_STATIC_VALUES = {
    VALIDATION_ERROR_CODE: 'tan-invalid',
    RESEND_ERROR_CODE: 'tan-resent',
    VALIDATION_REMAINING_TRIES: 'mTan-validation-remaining-tries',
    RESEND_REMAINING_TRIES: 'mTan-resend-remaining-tries',
    INVALID_MTAN: 'invalid-mtan',
    VALIDATION_MAXED_OUT: 'mtan-limit-reached-for-submit',
    RESEND_MAXED_OUT: 'max-resend-reached',
    USER_BLOCKED: 'user-blocked-for-mTan',
    CLOSE_Button: 'common.buttons.close.std-headline',
    CUSTOMER_ONBOARDING: 'cs-customer-onboarding.E400F_GENERAL_ERROR',
};

/** TOKEN_STORAGE */
export const TOKEN_STORAGE = {
    memory: 'memory',
    session: 'session',
};
